module.exports = __webpack_public_path__ + "static/fliq.1795136e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fliq.png
// module id = 575
// module chunks = 35783957827783